import { PublicTerminyPage } from "@/features/hca-public";
import { PublicShellWithDiagnoza } from "@/route-helpers/public-shell-with-diagnoza";
import { usePageMeta } from "@/shared/seo/use-page-meta";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/terminy")({
  component: TerminyRoute,
});

function TerminyRoute() {
  usePageMeta({
    title: "Termíny seminářů",
    description:
      "Nejbližší volné termíny otevřených seminářů a tréninků HCA Moravia. Rezervujte si místo na kurzu leadershipu, obchodní komunikace nebo rozvoje managementu.",
    path: "/terminy",
  });
  return (
    <PublicShellWithDiagnoza>
      <PublicTerminyPage />
    </PublicShellWithDiagnoza>
  );
}
